const getLastDirectoryFromUrl = (url) => {
  let slug = url.split('?');
  slug = slug[0];
  // Get the last path:
  slug = slug.split('/');

  return slug[slug.length - 1];
};

export default getLastDirectoryFromUrl;
